module.exports = __webpack_public_path__ + "img/dasa.25e27cb2.svg";